export enum DebugLevel {
    INSANE = 100000000,
    DEBUG = 99,
    LOG = 50,
    INFO = 40,
    INFO_WITH_INFO_TYPE = 39,
    WARN = 30,
    WARN_WITH_WARN_TYPE = 29,
    ERROR = 20,
    ERROR_WITH_ERROR_TYPE = 19,
    CRITICAL = 10,
    NONE = 0,
}

// Obfuscated localStorage key for debug mode
const PRISM_DEBUG_KEY = "prism_vd_2024";

export const alwaysLogLevel = DebugLevel.ERROR;
export let debuggingMode = false;
export let debugLevel = DebugLevel.ERROR;

// Initialize debug mode from localStorage
export function initializeDebugMode() {
    const storedValue = localStorage.getItem(PRISM_DEBUG_KEY);
    if (storedValue === 'true') {
        debuggingMode = true;
        debugLevel = DebugLevel.DEBUG;
        console.log("Debug mode initialized from localStorage");
    }
}

export function shouldLog(level: DebugLevel) {
    //return true;
    return alwaysLogLevel > level || (debuggingMode && debugLevel >= level);
}

export function SQW_Log(level: DebugLevel, message: any, ...optionalParams: any[]) {
    if (shouldLog(level)) {
        if (level === DebugLevel.INFO_WITH_INFO_TYPE) console.info(message, ...optionalParams);
        else if (level === DebugLevel.WARN_WITH_WARN_TYPE) console.warn(message, ...optionalParams);
        else if (level === DebugLevel.ERROR_WITH_ERROR_TYPE)
            console.error(message, ...optionalParams);
        else console.log(message, ...optionalParams);
    }
}

export function setDebuggingMode(debLevel: string) {
    debuggingMode = true;
    debugLevel = Number(debLevel);

    if (isNaN(debugLevel)) debugLevel = DebugLevel.ERROR;

    SQW_Log(
        DebugLevel.WARN_WITH_WARN_TYPE,
        "**********************Debugging Mode Enabled.***************************",
    );
}

export function toggleDebugMode() {
    debuggingMode = !debuggingMode;
    if (debuggingMode) {
        debugLevel = DebugLevel.DEBUG;
        localStorage.setItem(PRISM_DEBUG_KEY, 'true');
        console.log("Debug mode enabled");
    } else {
        debugLevel = DebugLevel.ERROR;
        localStorage.removeItem(PRISM_DEBUG_KEY);
        console.log("Debug mode disabled");
    }
    return debuggingMode;
}

export function isDebugModeEnabled() {
    return debuggingMode;
}

